// Search helpers for the Attendance page. A name search matches BOTH the
// English and the Arabic name regardless of the UI language, and Arabic is
// normalised so common spelling variants still match (أ/إ/آ → ا, ة → ه,
// ى → ي, diacritics and tatweel removed).

export const normalizeSearchText = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[ً-ٰٟـ]/g, "") // tashkeel + superscript alef + tatweel
    .replace(/[أإآٱ]/g, "ا")
    .replace(/ة/g, "ه")
    .replace(/ى/g, "ي")
    .replace(/ؤ/g, "و")
    .replace(/ئ/g, "ي")
    .replace(/\s+/g, " ")
    .trim();

// True when `term` matches any of the given names (or the employee id).
export const matchesEmployeeSearch = (term, names, employeeId) => {
  const needle = normalizeSearchText(term);
  if (!needle) return true;
  if (String(employeeId ?? "").includes(String(term).trim())) return true;
  return names.some((n) => n && normalizeSearchText(n).includes(needle));
};
